import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import * as PostProps from 'js/common/proptypes/post_props';

import PostGridCollection from './post_grid_collection';
import PostGridItem from '../post_grid_item';

const PostGrid = ({
    posts,
    cardProps,
    partitionContent,
    undistributedContent,
    getCompositionMetricsByCompositionId
}) => {
    const postCollections = R.reduce(
        (collections, post) => {
            const element = (
                <PostGridItem
                    {...cardProps}
                    post={post}
                    key={post.content_metadata_id}
                    getCompositionMetricsByCompositionId={getCompositionMetricsByCompositionId}
                />
            );

            if (R.prop('content_distribution_metadata', post)) {
                return R.evolve(
                    {
                        distributed: R.append(element)
                    },
                    collections
                );
            }

            return R.evolve(
                {
                    undistributed: R.append(element)
                },
                collections
            );
        },
        {distributed: [], undistributed: []},
        posts
    );

    if (!partitionContent) {
        const allPosts = R.pipe(R.values, R.flatten)(postCollections);

        return (
            <PostGridCollection
                getCompositionMetricsByCompositionId={getCompositionMetricsByCompositionId}
                posts={allPosts}
                defaultExpanded
            />
        );
    }

    return (
        <div>
            <div className="row">
                <PostGridCollection
                    getCompositionMetricsByCompositionId={getCompositionMetricsByCompositionId}
                    posts={postCollections.distributed}
                    defaultExpanded
                />
            </div>
            {undistributedContent && (
                <div className="row">
                    <PostGridCollection
                        getCompositionMetricsByCompositionId={getCompositionMetricsByCompositionId}
                        posts={postCollections.undistributed}
                        title="Undistributed Content"
                        defaultExpanded
                        isExpandable={false}
                    />
                </div>
            )}
        </div>
    );
};

PostGrid.defaultProps = {
    unpartitioned: false
};

PostGrid.propTypes = {
    posts: PropTypes.arrayOf(PropTypes.shape(PostProps.POST)),
    cardProps: PropTypes.shape({
        currentCardSize: PropTypes.string.isRequired,
        setPostScore: PropTypes.func.isRequired,
        showPostScore: PropTypes.bool.isRequired,
        setSelectedPost: PropTypes.func.isRequired,
        setSelectedPostAndComment: PropTypes.func.isRequired,
        showKoer: PropTypes.number.isRequired,
        showViews: PropTypes.number.isRequired,
        showAvgScore: PropTypes.bool.isRequired
    }).isRequired
};

export default PostGrid;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/post_grid/index.js